/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_Swap_Undo_LoggedInputs */

const en_us2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You already logged a set of ${i?.name}, and it stays. To go back, use Swap.`)
};

const pt_br2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você já registrou série de ${i?.name}, e ela fica. Para voltar, use Trocar.`)
};

const es_419_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ya registraste una serie de ${i?.name}, y se queda. Para volver, usa Cambiar.`)
};

const pt_pt2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Já registaste uma série de ${i?.name}, e ela fica. Para voltar atrás, usa Trocar.`)
};

const fr_fr2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as déjà enregistré une série de ${i?.name}, elle est conservée. Pour revenir, utilise Changer.`)
};

const de_de2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast schon einen Satz ${i?.name} erfasst, und der bleibt. Zum Zurückwechseln nutze Tauschen.`)
};

const it_it2_workout_swap_undo_logged = /** @type {(inputs: Workout_Swap_Undo_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai già registrato una serie di ${i?.name}, e resta. Per tornare indietro, usa Cambia.`)
};

/**
* | output |
* | --- |
* | "You already logged a set of {name}, and it stays. To go back, use Swap." |
*
* @param {Workout_Swap_Undo_LoggedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_undo_logged = /** @type {((inputs: Workout_Swap_Undo_LoggedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Undo_LoggedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_undo_logged(inputs)
	if (locale === "es-419") return es_419_workout_swap_undo_logged(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_undo_logged(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_undo_logged(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_undo_logged(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_undo_logged(inputs)
	return en_us2_workout_swap_undo_logged(inputs)
});
export { workout_swap_undo_logged as "workout-swap.undo_logged" }